import { scrollToId } from "@/lib/scroll";

const studies = [
    {
        name: "Prime Renovations",
        place: "Edmonton, AB",
        job: "A renovation company needed quote requests, service pages, and a phone number a visitor can tap.",
        built: "A site organized around the work they sell, with click-to-call and a path to request a quote.",
        href: "https://www.primerenovations.info",
    },
    {
        name: "Trendz Furniture",
        place: "Edmonton, AB",
        job: "A furniture shop needed the rooms, the cart, financing, and the showroom in one place.",
        built: "A retail site with room collections, a cart, financing, and showroom details.",
        href: "https://www.trendzfurniture.ca",
    },
    {
        name: "Northcrest Homes",
        place: "Calgary, AB",
        job: "A custom-home builder needed a way for someone to estimate a build before they book a conversation.",
        built: "Galleries, the construction process, and a two-minute build-cost estimator.",
        href: "https://northcrest-home-builders.vercel.app",
    },
];

export default function CaseStudies() {
    return (
        <section id="case-studies" data-testid="case-studies" className="bg-[#f6f7fb] px-5 py-16 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <p className="font-display text-xs font-bold uppercase tracking-[0.16em] text-[#2B50FF]">Case studies</p>
                <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-[#0a0a0b] sm:text-4xl">
                    What we built, and the job it had to do.
                </h2>
                <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-[#5b5b66]">
                    Three live sites. The job each one had to do, and what shipped.
                </p>
                <div className="mt-10 grid gap-5 lg:grid-cols-3">
                    {studies.map((study) => (
                        <article key={study.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-black/5">
                            <p className="text-xs font-semibold uppercase tracking-wide text-[#8a8a95]">{study.place}</p>
                            <h3 className="mt-2 font-display text-xl font-extrabold text-[#0a0a0b]">{study.name}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-[#5b5b66]">{study.job}</p>
                            <p className="mt-3 text-sm leading-relaxed text-[#0a0a0b]">{study.built}</p>
                            <a
                                href={study.href}
                                target="_blank"
                                rel="noreferrer"
                                className="mt-5 text-sm font-semibold text-[#2B50FF] underline underline-offset-4"
                            >
                                View the site
                            </a>
                        </article>
                    ))}
                </div>
                <button
                    type="button"
                    onClick={() => scrollToId("#work")}
                    className="mt-8 text-sm font-semibold text-[#0a0a0b] underline underline-offset-4"
                >
                    All websites
                </button>
            </div>
        </section>
    );
}
